import {
  // 级联国家筛选器
  REGION as REGION_SELECT_FILTER,
  // CheckboxGroup多选Mobile数据源 筛选器
  ICONABLE_CHECKBOX_SELECT as ICONABLE_CHECKBOX_SELECT_FILTER,
  // 是否显示热度国家筛选器
  HEAT_MAP as HEAT_MAP_SELECT_FILTER,
  // 是否显示前n个国家筛选器
  SHOW_TOP_COUNTRIES as SHOW_TOP_COUNTRIES_SELECT_FILTER,
} from '@/pages/intelligence/components/Filter/FilterBase/_config';

export const getInitialFormValue = (isOperate: boolean, filterExtend: any, defaultFormValue: any) => {
  // 没有操作过筛选器，不继承
  if (!isOperate) return defaultFormValue || {};

  /** 各个筛选器的继承值 **/
  const regionFilterExtend = filterExtend?.[REGION_SELECT_FILTER];
  const dataSourceFilterExtend = filterExtend?.[ICONABLE_CHECKBOX_SELECT_FILTER];
  const showHeatMapFilterExtend = filterExtend?.[HEAT_MAP_SELECT_FILTER];
  const showCountriesFilterExtend = filterExtend?.[SHOW_TOP_COUNTRIES_SELECT_FILTER];
  /** 各个筛选器的继承值 **/

  /** 各个筛选器的默认值 **/
  const regionDefault = defaultFormValue?.[REGION_SELECT_FILTER];
  const dataSourceDefault = defaultFormValue?.[ICONABLE_CHECKBOX_SELECT_FILTER];
  const showHeatMapDefault = defaultFormValue?.[HEAT_MAP_SELECT_FILTER];
  const showCountriesDefault = defaultFormValue?.[SHOW_TOP_COUNTRIES_SELECT_FILTER];
  /** 各个筛选器的默认值 **/

  return {
    // 级联国家筛选器
    [REGION_SELECT_FILTER]: {
      type: regionFilterExtend?.filterType || regionDefault?.type,
      regions: regionFilterExtend?.filterRegions || regionDefault?.regions,
      markets: regionFilterExtend?.filterMarkets || regionDefault?.markets,
    },
    // CheckboxGroup多选Mobile数据源 筛选器
    [ICONABLE_CHECKBOX_SELECT_FILTER]: {
      value: dataSourceFilterExtend?.value?.length ? dataSourceFilterExtend?.value : dataSourceDefault?.value,
    },
    // 是否显示热度国家筛选器
    [HEAT_MAP_SELECT_FILTER]: {
      value: showHeatMapFilterExtend?.value ?? showHeatMapDefault?.value,
    },
    // 是否显示前n个国家筛选器
    [SHOW_TOP_COUNTRIES_SELECT_FILTER]: {
      value: showCountriesFilterExtend?.value ?? showCountriesDefault?.value,
    },
  };
};
